import { LeadServiceJava } from "../../../service/lead-service-java-api";
import { fetchDataSuccess as fetchMetaDataSuccess } from "../../shared/meta-tags/actions";
import faqFormatter from "../../../utils/helpers/faq-formatter";
import { VehicleService } from "../../../service/vehicle-service";
import { setDetails } from "../franchise/actions";

export const checkForUserInterest = (token) => () => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.checkUserInterest(token)
            .then(response => resolve(response))
            .catch((err) => reject(err));
    });
};

export const fetchCMSData = (payload) => (dispatch) => {
    return new Promise((resolve, reject) => {
        VehicleService.getSeoContent(payload)
            .then(response => {
                const { detail } = response.data || {};

                if (detail.seo_content) {
                    fetchMetaDataSuccess(response.seo_content);
                }
                dispatch(setDetails({ faqList: faqFormatter(detail.faqs || {}) }));
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};
